import { Box } from '@mui/material';

export const CustomNoRowsOverlay = ({ label }: { label: string }) => (
  <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" justifyContent="center" height="100%">
    <Box fontSize={14}>{label}</Box>
  </Box>
);
